import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import TSTable, { EditButtonTableCell, DeleteButtonTableCell, SwitchTableCell, DateTableCell } from '@ts-core/components/Table';
import { TSTableColumn } from '@ts-core/components/Table/TSTable/TSTable';

import { ProfessorActivity } from '../../types';

export interface ActivitiesTableProps {
  activities?: ProfessorActivity[];
  loading?: boolean;

  onToggleActivity: (activity: ProfessorActivity) => void;
  onEditActivity: (activity: ProfessorActivity) => void;
  onClickActivity: (activity: ProfessorActivity) => void;
  onDeleteActivity: (activity: ProfessorActivity) => void;
}

const ActivitiesTable = (props: ActivitiesTableProps) => {
  const intl = useIntl();
  const { activities, loading = false, onToggleActivity, onEditActivity, onClickActivity, onDeleteActivity } = props;

  const getActionsCell = useCallback(
    (value: any, _: any, activity: ProfessorActivity) => {
      return (
        <Box display="flex" justifyContent="flex-end">
          {onEditActivity && <EditButtonTableCell item={activity} onClick={onEditActivity} />}
          <Box width={24} />
          {onDeleteActivity && (
            <DeleteButtonTableCell
              message={intl.formatMessage(
                {
                  id: 'dialog.confirmRemoveItem.title',
                },
                { item: activity.name }
              )}
              item={activity}
              onConfirm={onDeleteActivity}
            />
          )}
        </Box>
      );
    },
    [intl, onEditActivity, onDeleteActivity]
  );

  const columns = useMemo(
    (): TSTableColumn<ProfessorActivity>[] => [
      {
        Header: 'Activa',
        accessor: 'id',
        valueTransformer: (_value, _, activity) => <SwitchTableCell item={activity} onChange={onToggleActivity} />,
      },
      {
        Header: 'Nombre',
        accessor: 'name',
      },
      {
        Header: 'Fecha Límite',
        accessor: 'deadline',
        valueTransformer: (value: any) => <DateTableCell date={value} />,
      },
      { Header: '', accessor: 'id', valueTransformer: getActionsCell },
    ],
    [onToggleActivity, getActionsCell]
  );

  return <TSTable loading={loading} columns={columns} data={activities} onSelectRow={onClickActivity} />;
};

export default ActivitiesTable;
